export default "__VITE_ASSET__CPC$73US__"